import type { Renderer } from './renderer';

const loadRenderer = async (): Promise<Renderer> => {
  const renderer = await import(/* webpackChunkName: "3-render-renderer" */ 'bootstrap/entries/3-render/renderer');

  return renderer.default;
};

export default loadRenderer;
